//引入axios
import axios from "axios";
// 设置默认接口地址
// axios.defaults.baseURL = "http://192.168.8.250:6080/arcgis/rest/services/Vector/"
//暴露axios
// export default axios

// 环境的切换
// requstUrl 见 public\js\port.js 为方便打包之后更改请求接口地址
import get from "lodash/get";
// import storage from 'store';
let baseUrl = requstUrl;
// let baseUrl = 'http://10.20.40.9:8084';
// if (process.env.NODE_ENV === 'development') {
//     baseUrl = `${"http://192.168.8.223:8086"}/api/system`
// } else if (process.env.NODE_ENV === 'production') {
//     //这是服务器地址
//     baseUrl = `${requstUrl}/api/system`
// }
// 创建 axios 实例

const request = axios.create({
  baseURL: baseUrl, //设置baseUrl
  timeout: 30000, // 请求超时时间
});
//请求拦截
request.interceptors.request.use((config) => {
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  let tokenStr = sessionStorage.getItem("userToken");
  if (tokenStr) {
    tokenStr = tokenStr.substring(1, tokenStr.length - 1);
    config.headers.Authorization = tokenStr;
  }
  return config;
}, errorHandler);
// 异常拦截处理器
const errorHandler = (error) => {
  const status = get(error, "response.status");
  switch (status) {
    /* eslint-disable no-param-reassign */
    case 400:
      error.message = "请求错误";
      break;
    case 401:
      error.message = "未授权，请登录";
      break;
    case 403:
      error.message = "拒绝访问";
      break;
    case 404:
      error.message = `请求地址出错: ${error.response.config.url}`;
      break;
    case 408:
      error.message = "请求超时";
      break;
    case 500:
      error.message = "服务器内部错误";
      break;
    case 501:
      error.message = "服务未实现";
      break;
    case 502:
      error.message = "网关错误";
      break;
    case 503:
      error.message = "服务不可用";
      break;
    case 504:
      error.message = "网关超时";
      break;
    case 505:
      error.message = "HTTP版本不受支持";
      break;
    default:
      break;
    /* eslint-disabled */
  }
  return Promise.reject(error);
};

export default request;
